import React, { useEffect, useState } from "react";
import { Flex, theme } from "antd";
import { ShopOutlined, DownOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { lsSelectedCompany } from "../../../constans/auth";
import { useHybridResponsive } from "../../shared";
import { ArrowLeftRight } from "lucide-react";

const CompanySwitch: React.FC = () => {
  const [companyName, setCompanyName] = useState<string>('');
  const { isMobile } = useHybridResponsive();
  const { token } = theme.useToken();

  const navigate = useNavigate();

  useEffect(() => {
    const data = localStorage.getItem(lsSelectedCompany);
    if (!data || data.trim() === '') {
      navigate('/empresa/select');
      return;
    }
    try {
      const parsed = JSON.parse(data);
      if (!parsed || !parsed.name_company) {
        navigate('/empresa/select');
        return;
      }
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setCompanyName(parsed.name_company);
    } catch {
      navigate('/empresa/select');
    }
  }, [navigate]);

  return (
    <Link to="/empresa/select" style={{ marginTop: "15px" }}>
      <Flex
        justify="space-between"
        align="center"
        style={{
          cursor: "pointer",
          width: isMobile ? "60%" : "80%",
          maxWidth: isMobile ? "450px" : "250px",
          margin: "0 auto",
          background: isMobile ? token.colorBgContainer : "transparent",
          border: isMobile ? `1px solid ${token.colorBorder}` : "none",
          borderRadius: "15px",
          padding: "2px 10px",
        }}
      >
        <Flex align="center">
          <Flex
            align="center"
            justify="center"
            style={{
              width: "40px",
              height: "30px",
              borderRadius: "8px",
              color: token.colorPrimary,
              marginRight: "10px",
            }}
          >
            <ShopOutlined style={{ fontSize: "24px" }} />
          </Flex>
          <div style={{ textAlign: "left" }}>
            <p
              style={{ fontSize: "12px", color: token.colorTextSecondary, fontWeight: "500", margin: "17px 0 0" }}
            >
              Empresa Actual:
            </p>
            <p
              style={{ fontSize: "14px", color: token.colorText, fontWeight: "bold", marginTop: "4px" }}
            >
              {companyName}
            </p>
          </div>
        </Flex>
        <ArrowLeftRight style={{ color: token.colorIcon, width: isMobile ? "40px" : "20px" }} />
      </Flex>
    </Link>
  );
};

export default CompanySwitch;
